import styled from 'styled-components';
import { colors } from 'stylesheets';

export const BoxLocals = styled.div`
  margin: 30px auto;
  width: 92%;
  min-height: 500px;
  height: auto;
  background: ${colors.white};
  border: 1px solid ${colors.greyLight};
  border-radius: 3px;
  padding: 20px 25px;
`;

export const Footer = styled.div`
  display: flex;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-right: 24px;
  padding-left: 24px;

  & ul {
    margin: 0;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 45px;
  margin-top: 20px;
`;

export const SearchFail = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 2% auto;
  h3 {
    margin: 40px auto 20px;
    font-weight: 800;
    font-size: 17px;
  }
  img {
    max-width: 150px;
  }
  p {
    font-size: 13px;
    text-align: center;
  }
`;
